const PROJECTION_LAYER = "geolocation";
const DEGREES = 180 / Math.PI;

export {PROJECTION_LAYER, DEGREES};
